import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {CustomHttp} from '../shared/custom.http';
import 'rxjs/add/operator/toPromise';
import {DPTimeSheet} from './model/dp-timesheet';

@Injectable()
export class DPTimeSheetService {

    private projectUrl = '/demandportal/timesheet';  // URL to web api

    constructor(private router: Router, private http: CustomHttp) {
    }
    getTimeSheet(timesheet_id: number) {
        const url = `${this.projectUrl}?timeSheetId=${timesheet_id}`;
        return this.http.get(url, {body: ''});
    }
    getTimeSheetsByProjectId(project_id: number) {
        const url = `/demandportal/project?projectId=${project_id}`;
        return this.http.get(url, {body: ''});
    }
    createTimeSheet(project_id: number, timesheet: DPTimeSheet): Promise<DPTimeSheet> {
        const url = `${this.projectUrl}?projectId=${project_id}`;
        return this.http.post(url, JSON.stringify(timesheet));
    }

    updateTimeSheet(timesheet: DPTimeSheet) {
        const url = `${this.projectUrl}?timeSheetId=${timesheet.timesheet_id}`;
        return this.http.put(url, JSON.stringify(timesheet));
    }
}



// WEBPACK FOOTER //
// ./src/app/portalv1/dp-timesheet.service.ts